module.exports = __webpack_public_path__ + "img/logo.28a71e84.png";